import { lazyComponent } from '../core/components/LazyComponent';
import { RouteObject, useRoutes } from 'react-router-dom';
import App from '../App';
import { HelpView } from '../core/pages/HelpView';
import { PageNotImplementedView } from '../core/pages/PageNotImplementedView';
import { PageNotFoundView } from '../core/pages/PageNotFoundView';
import HomeView from '../modules/home/HomeView';
import DeathReportView from '../modules/members/deathReport/addEdit/DeathReportView';
import { SecureFileUploadView } from '../modules/members/secureFileUpload/uploadDocs/SecureFileUploadView';
import ReleaseNotesView from '../modules/utility/releaseNote/note/ReleaseNotesView';
import InitApp from '../modules/members/ora/memberCreate/0_0_InitApp';
import PrintApplication from '../modules/members/ora/memberCreate/10_1_PrintApplication';
import DocuSignResponseView from '../modules/members/ora/memberCreate/12_0_1DocuSignResponseView';
import ApplicationLayout from '../modules/members/ora/memberCreate/ApplicationLayout';
import { NotAuthorizedView } from '../core/pages/NotAuthorizedView';
import LogoutView from '../modules/home/LogoutView';
import SpcLayout from '../modules/members/spc/calculator/SpcLayout';
import SpcSavedEstimates from '../modules/members/spc/calculator/0_1_SpcSavedEstimates';
import SpcInitApp from '../modules/members/spc/calculator/0_0_SpcInitApp';
import PrintEstimate from '../modules/members/spc/calculator/5_1_PrintEstimate';

export function RouteConfig() {

  let corePublicRoutes: Array<RouteObject> = [
    { path: '', element: lazyComponent('modules/home/HomeView') },
    { path: '', element: <HomeView /> },
    { path: '/logout', element: <LogoutView /> },
    { path: 'help/:id', element: <HelpView /> },
    { path: 'unimplemented', element: <PageNotImplementedView /> },
    { path: 'noauthorization', element: <NotAuthorizedView /> },
    { path: 'members/upload-files/:reqId/:key', element: <SecureFileUploadView /> },
    { path: 'members/report-death', element: <DeathReportView /> },
    { path: '/utility/release-notes', element: <ReleaseNotesView /> },
    { path: '*', element: <PageNotFoundView /> },
  ];

  let retirementPublicRoutes: Array<RouteObject> = [
    { path: 'ora', element: <InitApp /> },
    { path: 'ora/application/:memberId/*', element: <ApplicationLayout /> },
    { path: 'ora/application/:memberId/print/:submissionId', element: <PrintApplication /> },
    { path: 'ora/application/docu-sign-response/:submissionId/:memberId/:envolopeId/:documentId/', element: <DocuSignResponseView /> },
  ];

  let servicePurchasePublicRoutes: Array<RouteObject> = [
    
    { path: 'spc', element: <SpcInitApp /> },
    { path: 'spc/estimate/saved-estimates/:memberId', element: <SpcSavedEstimates /> },
    { path: 'spc/estimate/:memberId/*', element: <SpcLayout /> },
    { path: 'spc/estimate/:memberId/:spcTypeSubId/print', element: <PrintEstimate /> },
  ];

  corePublicRoutes.push(...retirementPublicRoutes);
  corePublicRoutes.push(...servicePurchasePublicRoutes);
  let publicRoutes = new Array<RouteObject>;
  publicRoutes.push(...corePublicRoutes);

  const element = useRoutes([
    { path: '', element: <App />, children: [{ children: publicRoutes }] },
  ]);
  return element;
}
